export default __webpack_public_path__ + "static/banner5_mobile-9979c053dccf7e230878686b66aa4795.png";